import Header from "common/header";
import Loader from "common/loader";
import SideBar from "common/sidebar";
import backIcon from "include/images/chevron-left.svg";
import { isEmpty } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  getBattleGameAnalytics,
  loadDailyProgression,
  loadFunnel,
  loadTotalAttempts,
  loadMissionStats,
  loadMissionDailyProgressionStats,
} from "store/battleGameAnalytics";
import ViewAllAttemptsFlyer from "./flyers/viewAllAttempsFlyer";
import ViewAllDayProgressionFlyer from "./flyers/viewAllDayProgressionFlyer";

const BattleGameStats = (props) => {
  const ref = useRef();

  const [loadingMain, setLoadingMain] = useState(true);
  const [type, setType] = useState("attempts");
  const [showViewAll, setShowViewAll] = useState(false);

  const { attempts, dailyProgression, funnel, bgMissionStats, bgMissionDailyProgressStats } =
    props.getBattleGameAnalytics;

  const battleGame = props.location.state.battleGame;

  useEffect(() => {
    if (isEmpty(battleGame)) props.history.push("/telegram/settings/battle-game/games");
    props.loadTotalAttempts(battleGame?._id, () => {
      setLoadingMain(false);
    });
    props.loadDailyProgression(battleGame?._id);
    props.loadFunnel(battleGame?._id);
    props.loadMissionStats(battleGame?._id);
    props.loadMissionDailyProgressionStats(battleGame?._id);
  }, []);

  useEffect(() => {
    if (!loadingMain) ref?.current?.complete();
    else ref?.current?.continuousStart();
  }, [loadingMain]);
  const toggleViewAll = (e, type) => {
    if (e) e.preventDefault();
    if (type) setType(type);
    setShowViewAll(!showViewAll);
  };
  const totalGearsDailyProgression = Object.keys(dailyProgression)?.reduce((acc, key) => {
    return acc + dailyProgression[key].gears;
  }, 0);

  const totalAttemptsStart = Object.keys(attempts || {}).reduce((total, stage) => {
    return (
      total +
      Object.keys(attempts[stage] || {}).reduce((sum, level) => {
        return sum + (attempts[stage][level]?.start || 0);
      }, 0)
    );
  }, 0);
  const totalAttemptsCompeleted = Object.keys(attempts || {}).reduce((total, stage) => {
    return (
      total +
      Object.keys(attempts[stage] || {}).reduce((sum, level) => {
        return sum + (attempts[stage][level]?.completed || 0);
      }, 0)
    );
  }, 0);

  const sortDailyProgression = useCallback((a, b) => {
    // Extract numbers from each string (expected format: "stage X level Y")
    const numbersA = a.match(/\d+/g) || ["0", "0"];
    const numbersB = b.match(/\d+/g) || ["0", "0"];
    const stageA = parseInt(numbersA[0], 10);
    const levelA = parseInt(numbersA[1], 10);
    const stageB = parseInt(numbersB[0], 10);
    const levelB = parseInt(numbersB[1], 10);
    // Compare stage first and then level
    if (stageA !== stageB) return stageA - stageB;
    return levelA - levelB;
  }, []);

  const dailyProgressionArray =
    Object.keys(dailyProgression)?.length &&
    Object.keys(dailyProgression)?.map((day) => {
      const values = Object.keys(dailyProgression[day])
        ?.sort(sortDailyProgression)
        ?.filter((col) => col !== "gears" || totalGearsDailyProgression > 0)
        ?.map((stageLevel) => dailyProgression[day][stageLevel]);
      return { day, values };
    });

  const dailyProgressionArrayColumns =
    dailyProgression["D1"] &&
    Object.keys(dailyProgression["D1"])?.length > 0 &&
    Object.keys(dailyProgression["D1"])
      ?.sort(sortDailyProgression)
      ?.filter((item) => item !== "gears" || totalGearsDailyProgression > 0)
      ?.map((stageLevel) => stageLevel);

  // Assuming dailyProgressionArray is defined as in your code:
  const dailyProgressionColumnSums =
    dailyProgressionArray?.length > 0 &&
    dailyProgressionArray?.reduce((sums, { values }) => {
      values?.forEach((val, index) => {
        // Remove commas in the string and convert to a number
        if (typeof val === "number") {
          const num = parseInt(val);
          sums[index] = (sums[index] || 0) + num;
        }
        if (typeof val === "object") {
          const attempts = parseInt(val?.attempts);
          const completed = parseInt(val?.completed);
          const users = parseInt(val?.users);
          sums[index] = {
            attempts: (sums[index]?.attempts || 0) + attempts,
            completed: (sums[index]?.completed || 0) + completed,
            users: (sums[index]?.users || 0) + users,
          };
        }
      });
      return sums;
    }, []);

  return (
    <>
      <Header />
      <Loader loaderRef={ref} />
      <div className="page-wrapper add-dev-server-wrapper">
        <SideBar page="telegram-mini-app-battleGame" />
        {!loadingMain && (
          <div className="main-content-wrapper position-relative">
            <div className="mcw-header d-flex align-items-center">
              <h1>{battleGame?.name}</h1>
            </div>
            <div className="fwc-wrapper">
              <Link
                to="#"
                className="back-link-btn"
                onClick={(e) => {
                  e.preventDefault();
                  props.history.goBack();
                }}
              >
                <img src={backIcon} alt="" /> Back
              </Link>
              <div className="gcdr-widget-wrapper mt-2">
                <div className="gcdr-widget-box">
                  <ul className="gw-list d-flex flex-wrap">
                    <li>
                      <div className="gw-box">
                        <em>Total Number of Times Battle Game Attempted</em>
                        <h6>{totalAttemptsStart?.toLocaleString("en-us") ?? 0}</h6>
                      </div>
                    </li>
                    <li>
                      <div className="gw-box">
                        <em>Total Number of Times Battle Game Won</em>
                        <h6>{totalAttemptsCompeleted?.toLocaleString("en-us") ?? 0}</h6>
                      </div>
                    </li>
                    <li>
                      <div className="gw-box">
                        <em>Battle Game Victory %</em>
                        <h6>
                          {((totalAttemptsCompeleted / (totalAttemptsStart || 1)) * 100)?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) ?? 0}
                        </h6>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="gcdr-widget-box">
                  <div className="d-flex justify-content-between align-items-center">
                    <h4>Attempts</h4>
                  </div>
                  <div className="overflow-auto">
                    <table className="table custom-table-striped" style={{ tableLayout: "fixed" }}>
                      <thead>
                        <tr>
                          <th style={{ width: 138 }}>Status</th>
                          {Object.keys(attempts)
                            ?.sort((a, b) => a - b)
                            ?.map((stage) =>
                              Object.keys(attempts[stage])
                                ?.sort((a, b) => a - b)
                                ?.map((level) => (
                                  <th style={{ width: 120 }}>
                                    Stage {stage} Level {level}
                                  </th>
                                )),
                            )}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Started</td>
                          {Object.keys(attempts)
                            ?.sort((a, b) => a - b)
                            ?.map((stage) =>
                              Object.keys(attempts[stage])
                                ?.sort((a, b) => a - b)
                                ?.map((level) => <td>{attempts[stage][level]?.start?.toLocaleString("en-us")}</td>),
                            )}
                        </tr>
                        <tr>
                          <td>Completed</td>
                          {Object.keys(attempts)
                            ?.sort((a, b) => a - b)
                            ?.map((stage) =>
                              Object.keys(attempts[stage])
                                ?.sort((a, b) => a - b)
                                ?.map((level) => <td>{attempts[stage][level]?.completed?.toLocaleString("en-us")}</td>),
                            )}
                        </tr>
                        <tr>
                          <td>Users</td>
                          {Object.keys(attempts)
                            ?.sort((a, b) => a - b)
                            ?.map((stage) =>
                              Object.keys(attempts[stage])
                                ?.sort((a, b) => a - b)
                                ?.map((level) => <td>{attempts[stage][level]?.users?.toLocaleString("en-us")}</td>),
                            )}
                        </tr>
                        <tr>
                          <td>% Completion</td>
                          {Object.keys(attempts)
                            ?.sort((a, b) => a - b)
                            ?.map((stage) =>
                              Object.keys(attempts[stage])
                                ?.sort((a, b) => a - b)
                                ?.map((level) => (
                                  <td>
                                    {attempts[stage][level]?.completedPercent?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}{" "}
                                    %
                                  </td>
                                )),
                            )}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {!isEmpty(dailyProgression) && (
                  <div className="gcdr-widget-box">
                    <div className="d-flex justify-content-between align-items-center">
                      <h4>Daily Progression (Attempts/Completed/Users)</h4>
                    </div>
                    <div className="overflow-auto">
                      <table className="table custom-table-striped" style={{ tableLayout: "fixed" }}>
                        <thead>
                          <tr>
                            <th style={{ width: 120 }}>Day</th>
                            {dailyProgressionArrayColumns?.length > 0 &&
                              dailyProgressionArrayColumns?.map((stageLevel, index) => (
                                <th style={{ width: 120, textTransform: "capitalize" }} key={index}>
                                  {stageLevel}
                                </th>
                              ))}
                          </tr>
                        </thead>
                        <tbody className="text-capitalize">
                          {dailyProgressionArray?.length > 0 &&
                            dailyProgressionArray?.map(({ day, values }, index) => (
                              <tr key={index}>
                                <td>{day}</td>
                                {values?.map((progress, i) => (
                                  <td key={i}>
                                    {typeof progress === "number" ? (
                                      <>{progress?.toLocaleString("en-us")}</>
                                    ) : (
                                      <>
                                        {progress?.attempts?.toLocaleString("en-us")}/
                                        {progress?.completed?.toLocaleString("en-us")}/
                                        {progress?.users?.toLocaleString("en-us")}
                                      </>
                                    )}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          <tr>
                            <td>Total</td>
                            {dailyProgressionColumnSums?.length > 0 &&
                              dailyProgressionColumnSums?.map((sum, index) => (
                                <td key={index}>
                                  {typeof sum === "number" ? (
                                    <>{sum?.toLocaleString("en-us")}</>
                                  ) : (
                                    <>
                                      {sum?.attempts?.toLocaleString("en-us")}/{sum?.completed?.toLocaleString("en-us")}
                                      /{sum?.users?.toLocaleString("en-us")}
                                    </>
                                  )}
                                </td>
                              ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {!isEmpty(funnel) && (
                  <div className="gcdr-widget-box">
                    <div className="d-flex justify-content-between align-items-center">
                      <h4>Funnel</h4>
                    </div>
                    <div className="overflow-auto">
                      <table className="table custom-table-striped">
                        <thead>
                          <tr>
                            <th>Status</th>
                            {Object.keys(funnel)?.length > 0 &&
                              Object.keys(funnel)?.map((stage, index) => <th key={index}>Stage {stage}</th>)}
                          </tr>
                        </thead>
                        <tbody className="text-capitalize">
                          <tr>
                            <td>Start</td>
                            {Object.keys(funnel)?.length > 0 &&
                              Object.keys(funnel)?.map((stage, index) => (
                                <td key={index}>{funnel[stage].start?.toLocaleString("en-us")}</td>
                              ))}
                          </tr>
                          <tr>
                            <td>Completed</td>
                            {Object.keys(funnel)?.length > 0 &&
                              Object.keys(funnel)?.map((stage, index) => (
                                <td key={index}>{funnel[stage].completed?.toLocaleString("en-us")}</td>
                              ))}
                          </tr>
                          <tr>
                            <td>% Completion</td>
                            {Object.keys(funnel)?.length > 0 &&
                              Object.keys(funnel)?.map((stage, index) => (
                                <td key={index}>
                                  {funnel[stage].completedPercent?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                  %
                                </td>
                              ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {!isEmpty(bgMissionStats) && (
                  <div className="gcdr-widget-box">
                    <div className="d-flex justify-content-between align-items-center">
                      <h4>Missions</h4>
                    </div>
                    <div className="overflow-auto">
                      <table className="table custom-table-striped text-capitalize" style={{ tableLayout: "fixed" }}>
                        <thead>
                          <tr>
                            <th style={{ width: 150 }}>Missions</th>
                            {bgMissionStats?.map((game, index) => (
                              <th key={index} style={{ width: 120 }}>
                                {game?.bgGameName}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {[0, 1, 2, 3]?.map((level, index) => (
                            <tr>
                              <td>Level {level + 1}</td>
                              {bgMissionStats?.map((game, index) => (
                                <td key={index}>{game?.levelStats[level]?.count?.toLocaleString("en-us")}</td>
                              ))}
                            </tr>
                          ))}
                          <tr>
                            <td>Mission Completion %</td>
                            {bgMissionStats?.map((game, index) => (
                              <td key={index}>
                                {game?.missionCompletionPercentage?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}{" "}
                                %
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {!isEmpty(bgMissionDailyProgressStats) && (
                  <div className="gcdr-widget-box">
                    <div className="d-flex justify-content-between align-items-center">
                      <h4>Missions Daily Progress</h4>
                    </div>
                    <div className="overflow-auto">
                      <table className="table custom-table-striped text-capitalize" style={{ tableLayout: "fixed" }}>
                        <thead>
                          <tr>
                            <th style={{ width: 150 }}>Day</th>
                            <th style={{ width: 150 }}>Missions</th>
                            {bgMissionDailyProgressStats["D1"]?.map((game, index) => (
                              <th key={index} style={{ width: 120 }}>
                                {game?.bgGameName}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {Object.keys(bgMissionDailyProgressStats)?.map((day, index) => (
                            <>
                              {[0, 1, 2, 3]?.map((level, index) => (
                                <tr>
                                  {level === 0 && <td rowSpan={5}>{day}</td>}
                                  <td>Level {level + 1}</td>
                                  {bgMissionDailyProgressStats[day]?.map((game, index) => (
                                    <td key={index}>{game?.levelStats[level]?.count?.toLocaleString("en-us")}</td>
                                  ))}
                                </tr>
                              ))}

                              <tr>
                                <td>Mission Completion %</td>
                                {bgMissionDailyProgressStats[day]?.map((game, index) => (
                                  <td key={index}>
                                    {game?.missionCompletionPercentage?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}{" "}
                                    %
                                  </td>
                                ))}
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <ViewAllAttemptsFlyer
        attempts={attempts}
        showModal={showViewAll && type === "attempts"}
        toggleModal={toggleViewAll}
      />
      <ViewAllDayProgressionFlyer
        dailyProgression={dailyProgression}
        showModal={showViewAll && type === "dailyProgression"}
        toggleModal={toggleViewAll}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch) => ({
  loadTotalAttempts: (id, callback) => dispatch(loadTotalAttempts(id, callback)),
  loadDailyProgression: (id, callback) => dispatch(loadDailyProgression(id, callback)),
  loadFunnel: (id, callback) => dispatch(loadFunnel(id, callback)),
  loadMissionStats: (id, callback) => dispatch(loadMissionStats(id, callback)),
  loadMissionDailyProgressionStats: (id, callback) => dispatch(loadMissionDailyProgressionStats(id, callback)),
});
const mapStateToProps = (state) => ({
  getBattleGameAnalytics: getBattleGameAnalytics(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BattleGameStats));
